import type { TDashboardData } from '@/shared/types/dashboard.types';
import type { ILeasingFilesApi } from '@/shared/types/leasing-files.types';
import type { IPaymentScheduleApi } from '@/shared/types/payment-schedule.types';

import { ApiConnector } from './api.connector';

class LeasingApi extends ApiConnector {
  getDashboardData(): Promise<TDashboardData> {
    return this.call({ path: 'client-portal/dashboard' });
  }

  getLeasingFiles(contractId: string): Promise<ILeasingFilesApi> {
    return this.call({ path: `client-portal/contract/${contractId}/files` });
  }

  getPaymentSchedule(
    contractId: string,
    params?: IGetPaymentScheduleParams
  ): Promise<IPaymentScheduleApi> {
    return this.call({
      path: `client-portal/contract/${contractId}/payment-schedule`,
      params
    });
  }

  createDownPayment(contractId: string): Promise<ICreateDownPaymentApi> {
    return this.call({
      path: `client-portal/contract/${contractId}/down-payment`,
      method: 'post'
    });
  }

  uploadDownPaymentReceipt(
    contractId: string,
    receiptFile: File
  ): Promise<void> {
    const receiptFormData = new FormData();
    receiptFormData.append('file', receiptFile);

    return this.call({
      path: `client-portal/contract/${contractId}/down-payment/receipt`,
      method: 'post',
      body: receiptFormData
    });
  }

  createSchedulePayment(
    contractId: string
  ): Promise<ICreateSchedulePaymentApi> {
    return this.call({
      path: `client-portal/contract/${contractId}/schedule-payment`,
      method: 'post'
    });
  }
}

export const leasingApi = new LeasingApi();

interface IGetPaymentScheduleParams {
  offset?: number;
  limit?: number;
}

interface ICreateDownPaymentApi {
  checkout_url: string;
}

interface ICreateSchedulePaymentApi {
  checkout_url: string;
}
